<template>
  <svg
    class="cross-icon"
    xmlns="http://www.w3.org/2000/svg"
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
  >
    <path
      d="M7.78049 15L7 14.2195L10.2195 11L7 7.78049L7.78049 7L11 10.2195L14.2195 7L15 7.78049L11.7805 11L15 14.2195L14.2195 15L11 11.7805L7.78049 15Z"
      fill="#F2F2F2"
    />
  </svg>
</template>

<script>
export default {
  name: "CrossIcon",
};
</script>
